import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

export default {
  routes: [
    {
      name: "logs",
      // Filters live in the query string rather than in named routes or a path
      // param. The style guide's one-route-per-filter pattern is for mutually
      // exclusive toggles; these filters combine, so a route per combination
      // would be a dozen routes. The old `:query?` param held the free-text
      // path search, which the collection and document-ID filters replace.
      path: "logs",
      meta: {
        auth: () => store.getters.isAdmin(),
        icon: "logs",
        title: i18n.global.tc("Log", 100),
        crumbs: ["admin"],
        color: "admin",
      },
      component: () => import("pages/admin/Logs"),
    },
  ],

  dialogs: [
    {
      name: "log-view",
      path: "/admin/logs/:logID",
      meta: {
        auth: () => store.getters.isAdmin(),
        color: "admin",
      },
      component: () => import("../../../dialogs/admin/LogView"),
    },
  ],
};
